<template>
    <div v-if="open" class="cv3-modal-overlay" @click.self="close">
        <div class="cv3-note-modal">
            <header class="cv3-note-head">
                <div class="cv3-note-title !ppv2-text-white">
                    <MessageCircleIcon :size="17" />
                    <h2 class="!ppv2-text-white">{{ title }}</h2>
                </div>
                <button type="button" class="cv3-modal-close" @click="close"><XIcon :size="20" /></button>
            </header>
            <div class="cv3-note-body">
                <textarea ref="ta" v-model="text" rows="5" :placeholder="placeholder" class="cv3-note-textarea"></textarea>
            </div>
            <footer class="cv3-note-foot">
                <button type="button" class="cv3-acompte-btn" @click="close">{{ $t('checkout.v3.cancel_btn') }}</button>
                <button type="button" class="cv3-validate-pay" :disabled="store.busy" @click="save">
                    <CheckIcon :size="18" /> {{ $t('checkout.v3.save_btn') }}
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
import { MessageCircle as MessageCircleIcon, X as XIcon, Check as CheckIcon } from 'lucide-vue'

export default {
    name: 'NoteModal',
    components: { MessageCircleIcon, XIcon, CheckIcon },
    props: {
        store: { type: Object, required: true },
        open: { type: Boolean, default: false },
        title: {
            type: String,
            default() {
                return this.$t('checkout.v3.note_title_default')
            },
        },
        value: { type: String, default: '' },
        placeholder: {
            type: String,
            default() {
                return this.$t('checkout.v3.note_placeholder_default')
            },
        },
    },
    data() {
        return { text: this.value || '' }
    },
    watch: {
        open(v) {
            if (v) {
                this.text = this.value || ''
                this.$nextTick(() => this.$refs.ta && this.$refs.ta.focus())
            }
        },
    },
    methods: {
        close() {
            this.$emit('close')
        },
        save() {
            if (this.store.busy) return
            // The legacy endpoint stores the comment verbatim; empty string clears it.
            this.$emit('save', (this.text || '').trim())
        },
    },
}
</script>

<style scoped lang="scss">
.cv3-modal-overlay {
    position: fixed;
    inset: 0;
    z-index: 1100;
    background: rgba(3, 6, 20, 0.7);
    backdrop-filter: blur(3px);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
}
.cv3-note-modal {
    width: 100%;
    max-width: 480px;
    background: var(--cv3-panel);
    border: 1px solid var(--cv3-border-input);
    border-radius: 18px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    font-family: 'Poppins', sans-serif;
    color: var(--cv3-text);
}
.cv3-note-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid var(--cv3-border);
}
.cv3-note-title {
    display: flex;
    align-items: center;
    gap: 9px;
    h2 {
        margin: 0;
        font-size: 16px;
        font-weight: 700;
    }
}
.cv3-modal-close {
    border: 0;
    background: transparent;
    color: var(--cv3-muted);
    display: inline-flex;
}
.cv3-note-body {
    padding: 18px 20px;
}
.cv3-note-textarea {
    width: 100%;
    background: var(--cv3-input);
    border: 1px solid var(--cv3-border-input);
    border-radius: 10px;
    color: var(--cv3-text);
    padding: 11px 13px;
    font-size: 14px;
    font-family: 'Poppins', sans-serif;
    resize: vertical;
    &::placeholder {
        color: var(--cv3-muted);
    }
}
.cv3-note-foot {
    padding: 14px 20px;
    border-top: 1px solid var(--cv3-border);
    display: flex;
    gap: 10px;
}
.cv3-acompte-btn {
    flex: 0 0 auto;
    padding: 12px 18px;
    border-radius: 12px;
    border: 1px solid var(--cv3-border-input);
    background: transparent;
    color: var(--cv3-text-2);
    font-size: 14px;
    font-weight: 700;
}
.cv3-validate-pay {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px;
    border-radius: 12px;
    border: 0;
    background: var(--cv3-accent);
    color: #fff;
    font-size: 14px;
    font-weight: 600;
}
</style>
